// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__headerLink___hjQKK {
  margin-top: 8px;
}

.styles__section___muD7I {
  background-color: white;
  padding: 10px 10px 20px;
  width: 100%;
}

.styles__tableSection___FGgiy {
  background-color: white;
  margin-bottom: 20px;
  position: relative;
}

.styles__tableTitle___iJjv5 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]};
  border-radius: 3px 3px 0 0;
  box-shadow: 0 1px 0 0 rgba(58, 64, 68, 0.1);
  height: 50px;
  margin-bottom: 1px;
  padding: 16px 20px;
}

.styles__row___WLWl9 {
  align-items: center;
  padding: 12px 10px;
}

.styles__row___WLWl9:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

.styles__label___DEJ3w {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__table___Cobj7 {
  display: table;
  width: 100%;
}

.styles__thRow___ExFl1 {
  display: table-row;
}

.styles__tdRow___rmZvN {
  box-shadow: none;
  display: table-row;
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: all 0.25s;
}

.styles__tdRow___rmZvN:hover {
    background: white;
    box-shadow: none;
  }

.styles__selected___qwL9j {
}

.styles__selected___qwL9j .styles__tdCell___P9SmA {
    background: white;
  }

.styles__selected___qwL9j:hover .styles__tdCell___P9SmA {
      background: white;
    }

.styles__highlight___iiTKy {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]};
}

.styles__tdCell___P9SmA {
  background: rgba(255, 255, 255, 0.7);
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  display: table-cell;
  line-height: 26px;
  padding: 10px;
  vertical-align: top;
}

.styles__tdCell___P9SmA:first-child {
    padding-left: 20px;
  }

.styles__tdCell___P9SmA:last-child {
    padding-right: 20px;
  }

.styles__thCell___ywBPk {
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  color: transparent;
  font-size: 14px;
  line-height: 8px;
  padding-bottom: 16px;
  padding-top: 8px;
  white-space: nowrap;
}

.styles__thCell___ywBPk .styles__fixed___zxeUA {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  }

.styles__thCell___ywBPk:first-child {
    color: transparent;
  }

.styles__thCell___ywBPk:first-child .styles__fixed___zxeUA {
      color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    }

.styles__tableTickets___rfTQM {
}

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(2),
    .styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(3) {
      width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(2):nth-child(1n),
    .styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(3):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(2):last-child,
    .styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(3):last-child {
      margin-right: 0;
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(2):nth-child(5n),
    .styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(3):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(2):nth-child(5n + 1),
    .styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(3):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(1) {
      width: calc(99.9% * 1/5 - (30px - 30px * 1/5));
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(1):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(1):last-child {
      margin-right: 0;
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(1):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableTickets___rfTQM .styles__tdCell___P9SmA:nth-child(1):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableAccounts___Nk1mx .styles__tdRow___rmZvN {
    cursor: pointer;
  }

.styles__tableFees___CfCoQ {
}

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(2) {
      width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(2):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(2):last-child {
      margin-right: 0;
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(2):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(2):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(1),
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(3),
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(4) {
      width: calc(99.9% * 1/5 - (30px - 30px * 1/5));
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(1):nth-child(1n),
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(3):nth-child(1n),
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(4):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(1):last-child,
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(3):last-child,
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(4):last-child {
      margin-right: 0;
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(1):nth-child(5n),
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(3):nth-child(5n),
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(4):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(1):nth-child(5n + 1),
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(3):nth-child(5n + 1),
    .styles__tableFees___CfCoQ .styles__tdCell___P9SmA:nth-child(4):nth-child(5n + 1) {
      clear: both;
    }

.styles__docRow___I631d {
  padding: 12px 10px;
}

.styles__docRow___I631d:last-child {
    padding-bottom: 0;
  }

.styles__docLabel___GsyMp {
  margin-bottom: 3px;
}

.styles__pending___ncyRf,
.styles__incomplete___XSJz8 {
}

.styles__active___bTZBz,
.styles__approved___McRXX,
.styles__complete___Iw0hQ {
}

.styles__closed___Z1eWq,
.styles__rejected___u1z6W {
}

.styles__tableDefault___oEf4R {
  border-radius: 0 0 3px 3px;
  overflow-y: auto;
}

.styles__tableLarge___SsXgg {
  max-height: 75vh;
}

.styles__tableMedium___PqQG3 {
  max-height: 300px;
}

.styles__tableSmall___I1HVB {
  max-height: 203px;
}

.styles__button___N8c6u {
}

.styles__button___N8c6u > span {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    border-radius: 3px;
    color: white;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    line-height: initial;
    padding: 4px 8px;
    transition: all 0.25s;
  }

.styles__button___N8c6u > span:hover {
      opacity: 0.9;
    }

.styles__button___N8c6u > span div {
      border-bottom: none;
      cursor: pointer;
      margin: 0;
      padding: 0;
    }

.styles__remove___lFVn0 span {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
    border: none;
    border-radius: 3px;
    box-shadow: none;
    color: white;
    cursor: pointer;
    display: inline-block;
    font-size: 13px;
    font-weight: 700;
    padding: 0 0.5em;
    -webkit-text-decoration: none;
    text-decoration: none;
    text-shadow: none;
    transition: all 0.25s;
    width: auto;
  }

.styles__remove___lFVn0 span:hover {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
      box-shadow: none;
    }

.styles__remove___lFVn0 span:active,
    .styles__remove___lFVn0 span:focus {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
      border: none;
    }

.styles__noResults___b9teT {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__noValue___CXJOm {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__boldValue___fDqQj {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  font-weight: bold;
}

.styles__italicValue___tkUsM {
  font-style: italic;
}

.styles__monoValue___LMqyo {
  font-family: MaisonMono, monospace;
  text-align: right;
}

.styles__centeredValue___khy4Y {
  font-family: MaisonMono, monospace;
  text-align: center;
}

.styles__gpt___XV8WA {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]};
  border-radius: 3px;
  box-shadow: none;
  color: white;
  display: inline-block;
  font-family: MaisonNeue, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
  padding: 2px 4px;
  transition: all 0.25s;
}

.styles__gpt___XV8WA:hover {
    background: #253A4F;
  }

.styles__gpt___XV8WA a {
    box-shadow: none;
    color: white;
    display: block;
    font-size: 13px;
    left: -4px;
    padding: 1px;
    position: relative;
    text-align: center;
    width: calc(100% + 8px);
  }

.styles__floatRight____S2Pz {
  float: right;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Closings/components/Table/styles.css"],"names":[],"mappings":"AAIA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EAEvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EAEvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8DAAgC;EAChC,0BAA0B;EAC1B,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EAEnB,kBAAkB;AAMpB;;AAJE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;AAGF;EACE,oDAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAAqB;EAArB,qBAAqB;EACrB,qBAAqB;AAMvB;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;AAYA;;AATE;IACE,iBAAiB;EACnB;;AAGE;MACE,iBAAiB;IACnB;;AAIJ;EACE,+DAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,qEAAoC;EACpC,oDAAW;EAEX,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AASrB;;AAPE;IACE,kBAAkB;EACpB;;AAEA;IACE,mBAAmB;EACrB;;AAGF;EACE,qEAAoC;EACpC,kBAAkB;EAElB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AAarB;;AAXE;IACE,oDAAW;EACb;;AAEA;IACE,kBAAkB;EAKpB;;AAHE;MACE,oDAAW;IACb;;AAIJ;AAaA;;AATI;;MAEE,8CAAgB;IAClB;;AAHA;;MAEE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAHA;;MAEE,eAAgB;IAClB;;AAHA;;MAEE,eAAgB;MAAhB,YAAgB;IAClB;;AAHA;;MAEE,WAAgB;IAClB;;AAEA;MACE,8CAAgB;IAClB;;AAFA;MACE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAFA;MACE,eAAgB;IAClB;;AAFA;MACE,eAAgB;MAAhB,YAAgB;IAClB;;AAFA;MACE,WAAgB;IAClB;;AAKF;IACE,eAAe;EACjB;;AAGF;AAcA;;AAVI;MACE,8CAAgB;IAClB;;AAFA;MACE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAFA;MACE,eAAgB;IAClB;;AAFA;MACE,eAAgB;MAAhB,YAAgB;IAClB;;AAFA;MACE,WAAgB;IAClB;;AAEA;;;MAGE,8CAAgB;IAClB;;AAJA;;;MAGE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAJA;;;MAGE,eAAgB;IAClB;;AAJA;;;MAGE,eAAgB;MAAhB,YAAgB;IAClB;;AAJA;;;MAGE,WAAgB;IAClB;;AAIJ;EACE,kBAAkB;AAKpB;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EAEE,kBAAkB;AACpB;;AAEA;;AAGA;;AAEA;;;AAIA;;AAEA;;AAGA;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;AAyBA;;AAtBE;IACE,8DAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;EAYvB;;AAVE;MACE,YAAY;IACd;;AAEA;MACE,mBAAmB;MACnB,eAAe;MACf,SAAS;MACT,UAAU;IACZ;;AAKF;IACE,8DAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,6BAAqB;IAArB,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;EAYb;;AAVE;MACE,yDAAqB;MACrB,gBAAgB;IAClB;;AAEA;;MAEE,yDAAqB;MACrB,YAAY;IACd;;AAIJ;EACE,oDAAgB;AAElB;;AAEA;EACE,oDAAgB;AAElB;;AAEA;EACE,mDAAiB;EAEjB,iBAAiB;AACnB;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EAEE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EAEE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,wDAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AAiBvB;;AAfE;IACE,mBAAmB;EACrB;;AAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;EACzB;;AAGF;EACE,YAAY;AACd","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlue, gtBlueDark, borderColor, gtCardHeaderBG, gtGray, gtGreen, gtGPT, gtGreenDark, gtGreenLight, gtRed, gtRedDark, gtYellow, gtYellowLight, text, textLight, textDark from colors;\n\n.headerLink {\n  margin-top: 8px;\n}\n\n.section {\n  background-color: white;\n  composes: boxWrap clearfix from helpers;\n  padding: 10px 10px 20px;\n  width: 100%;\n}\n\n.tableSection {\n  background-color: white;\n  composes: card from helpers;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.tableTitle {\n  background-color: gtCardHeaderBG;\n  border-radius: 3px 3px 0 0;\n  box-shadow: 0 1px 0 0 rgba(58, 64, 68, 0.1);\n  height: 50px;\n  margin-bottom: 1px;\n  padding: 16px 20px;\n}\n\n.row {\n  align-items: center;\n  composes: row from helpers;\n  padding: 12px 10px;\n\n  &:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n}\n\n.label {\n  color: textLight;\n  font-size: 12px;\n}\n\n.table {\n  display: table;\n  width: 100%;\n}\n\n.thRow {\n  display: table-row;\n}\n\n.tdRow {\n  box-shadow: none;\n  display: table-row;\n  text-decoration: none;\n  transition: all 0.25s;\n\n  &:hover {\n    background: white;\n    box-shadow: none;\n  }\n}\n\n.selected {\n  composes: tdRow;\n\n  .tdCell {\n    background: white;\n  }\n\n  &:hover {\n    .tdCell {\n      background: white;\n    }\n  }\n}\n\n.highlight {\n  background-color: gtYellowLight;\n}\n\n.tdCell {\n  background: rgba(255, 255, 255, 0.7);\n  border-bottom: 1px solid borderColor;\n  color: text;\n  composes: clearfix from helpers;\n  display: table-cell;\n  line-height: 26px;\n  padding: 10px;\n  vertical-align: top;\n\n  &:first-child {\n    padding-left: 20px;\n  }\n\n  &:last-child {\n    padding-right: 20px;\n  }\n}\n\n.thCell {\n  border-bottom: 1px solid borderColor;\n  color: transparent;\n  composes: tdCell;\n  font-size: 14px;\n  line-height: 8px;\n  padding-bottom: 16px;\n  padding-top: 8px;\n  white-space: nowrap;\n\n  .fixed {\n    color: text;\n  }\n\n  &:first-child {\n    color: transparent;\n\n    .fixed {\n      color: text;\n    }\n  }\n}\n\n.tableTickets {\n  composes: table;\n\n  .tdCell {\n    &:nth-child(2),\n    &:nth-child(3) {\n      lost-column: 2/5;\n    }\n\n    &:nth-child(1) {\n      lost-column: 1/5;\n    }\n  }\n}\n\n.tableAccounts {\n  .tdRow {\n    cursor: pointer;\n  }\n}\n\n.tableFees {\n  composes: table;\n\n  .tdCell {\n    &:nth-child(2) {\n      lost-column: 2/5;\n    }\n\n    &:nth-child(1),\n    &:nth-child(3),\n    &:nth-child(4) {\n      lost-column: 1/5;\n    }\n  }\n}\n\n.docRow {\n  padding: 12px 10px;\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n}\n\n.docLabel {\n  composes: label;\n  margin-bottom: 3px;\n}\n\n.pending,\n.incomplete {\n  composes: statusPending from helpers;\n}\n\n.active,\n.approved,\n.complete {\n  composes: statusActive from helpers;\n}\n\n.closed,\n.rejected {\n  composes: statusRejected from helpers;\n}\n\n.tableDefault {\n  border-radius: 0 0 3px 3px;\n  overflow-y: auto;\n}\n\n.tableLarge {\n  composes: tableDefault;\n  max-height: 75vh;\n}\n\n.tableMedium {\n  composes: tableDefault;\n  max-height: 300px;\n}\n\n.tableSmall {\n  composes: tableDefault;\n  max-height: 203px;\n}\n\n.button {\n  composes: tdCell;\n\n  & > span {\n    background-color: gtBlue;\n    border-radius: 3px;\n    color: white;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 12px;\n    line-height: initial;\n    padding: 4px 8px;\n    transition: all 0.25s;\n\n    &:hover {\n      opacity: 0.9;\n    }\n\n    div {\n      border-bottom: none;\n      cursor: pointer;\n      margin: 0;\n      padding: 0;\n    }\n  }\n}\n\n.remove {\n  span {\n    background-color: gtRed;\n    border: none;\n    border-radius: 3px;\n    box-shadow: none;\n    color: white;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 13px;\n    font-weight: 700;\n    padding: 0 0.5em;\n    text-decoration: none;\n    text-shadow: none;\n    transition: all 0.25s;\n    width: auto;\n\n    &:hover {\n      background: gtRedDark;\n      box-shadow: none;\n    }\n\n    &:active,\n    &:focus {\n      background: gtRedDark;\n      border: none;\n    }\n  }\n}\n\n.noResults {\n  color: textLight;\n  composes: sectionNoMargin from helpers;\n}\n\n.noValue {\n  color: textLight;\n  composes: tdCell;\n}\n\n.boldValue {\n  color: gtBlueDark;\n  composes: tdCell;\n  font-weight: bold;\n}\n\n.italicValue {\n  composes: tdCell;\n  font-style: italic;\n}\n\n.monoValue {\n  composes: tdCell;\n  font-family: MaisonMono, monospace;\n  text-align: right;\n}\n\n.centeredValue {\n  composes: tdCell;\n  font-family: MaisonMono, monospace;\n  text-align: center;\n}\n\n.gpt {\n  background: gtGPT;\n  border-radius: 3px;\n  box-shadow: none;\n  color: white;\n  display: inline-block;\n  font-family: MaisonNeue, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: normal;\n  padding: 2px 4px;\n  transition: all 0.25s;\n\n  &:hover {\n    background: #253A4F;\n  }\n\n  a {\n    box-shadow: none;\n    color: white;\n    display: block;\n    font-size: 13px;\n    left: -4px;\n    padding: 1px;\n    position: relative;\n    text-align: center;\n    width: calc(100% + 8px);\n  }\n}\n\n.floatRight {\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"gtGreenDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenDark"]}`,
	"gtGreenLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"headerLink": `styles__headerLink___hjQKK`,
	"section": `styles__section___muD7I ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boxWrap"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"tableSection": `styles__tableSection___FGgiy ${___CSS_LOADER_ICSS_IMPORT_1___.locals["card"]}`,
	"tableTitle": `styles__tableTitle___iJjv5`,
	"row": `styles__row___WLWl9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"label": `styles__label___DEJ3w`,
	"table": `styles__table___Cobj7`,
	"thRow": `styles__thRow___ExFl1`,
	"tdRow": `styles__tdRow___rmZvN`,
	"selected": `styles__selected___qwL9j styles__tdRow___rmZvN`,
	"tdCell": `styles__tdCell___P9SmA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"highlight": `styles__highlight___iiTKy`,
	"thCell": `styles__thCell___ywBPk styles__tdCell___P9SmA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"fixed": `styles__fixed___zxeUA`,
	"tableTickets": `styles__tableTickets___rfTQM styles__table___Cobj7`,
	"tableAccounts": `styles__tableAccounts___Nk1mx`,
	"tableFees": `styles__tableFees___CfCoQ styles__table___Cobj7`,
	"docRow": `styles__docRow___I631d`,
	"docLabel": `styles__docLabel___GsyMp styles__label___DEJ3w`,
	"pending": `styles__pending___ncyRf ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"incomplete": `styles__incomplete___XSJz8 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"active": `styles__active___bTZBz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"approved": `styles__approved___McRXX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"complete": `styles__complete___Iw0hQ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"closed": `styles__closed___Z1eWq ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"rejected": `styles__rejected___u1z6W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"tableDefault": `styles__tableDefault___oEf4R`,
	"tableLarge": `styles__tableLarge___SsXgg styles__tableDefault___oEf4R`,
	"tableMedium": `styles__tableMedium___PqQG3 styles__tableDefault___oEf4R`,
	"tableSmall": `styles__tableSmall___I1HVB styles__tableDefault___oEf4R`,
	"button": `styles__button___N8c6u styles__tdCell___P9SmA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"remove": `styles__remove___lFVn0`,
	"noResults": `styles__noResults___b9teT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"noValue": `styles__noValue___CXJOm styles__tdCell___P9SmA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"boldValue": `styles__boldValue___fDqQj styles__tdCell___P9SmA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"italicValue": `styles__italicValue___tkUsM styles__tdCell___P9SmA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"monoValue": `styles__monoValue___LMqyo styles__tdCell___P9SmA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"centeredValue": `styles__centeredValue___khy4Y styles__tdCell___P9SmA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"gpt": `styles__gpt___XV8WA`,
	"floatRight": `styles__floatRight____S2Pz`
};
export default ___CSS_LOADER_EXPORT___;
